import { Formik } from "formik";
import Modal from "../../designComponents/Modal";
import { AcceptButton, LabelText } from "../Properties/Details/styles";
import { Input, InputGroup } from "./styles";
import * as Yup from "yup";
import MediaUploader from "../../designComponents/MediaUpload/MediaUpload";

type ValuesType = {
  icon: string | File;
  title: string;
  key: string;
  isActive: boolean;
};

const validationSchema = Yup.object().shape({
  icon: Yup.string()
    .required("Icon is required")
    .min(1, "Icon cannot be empty"),
  title: Yup.string()
    .required("Title is required")
    .min(2, "Title must be at least 2 characters"),
  key: Yup.string()
    .required("Key is required")
    .min(2, "Key must be at least 2 characters"),
  isActive: Yup.boolean().required("Status is required"),
});

function AddEditPaymentMethod({
  isOpen,
  onClose,
  initialValues,
  handleSubmit,
  type = "Add",
}: {
  isOpen: boolean;
  onClose: () => void;
  initialValues: ValuesType;
  handleSubmit: (values: ValuesType) => void;
  type?: "Add" | "Edit";
}) {
  return (
    <Modal
      isOpen={isOpen}
      halfWidth={true}
      onClose={onClose}
      title={`${type} Payment Method`}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => handleSubmit(values)}
        validationSchema={validationSchema}
      >
        {({
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
          handleBlur,
        }) => {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    overflowY: "auto",
                    maxHeight: 400,
                  }}
                >
                  <InputGroup>
                    <LabelText>Title</LabelText>
                    <Input
                      type="text"
                      value={values.title}
                      onChange={(e) => setFieldValue("title", e.target.value)}
                      onBlur={handleBlur("title")}
                      placeholder="Enter Title"
                    />
                    {touched.title && errors.title && (
                      <div style={{ color: "red", marginTop: 4 }}>
                        {errors.title}
                      </div>
                    )}
                  </InputGroup>

                  <InputGroup>
                    <LabelText>Key</LabelText>
                    <Input
                      type="text"
                      value={values.key}
                      onChange={(e) => setFieldValue("key", e.target.value)}
                      onBlur={handleBlur("key")}
                      placeholder="Enter Key"
                    />
                    {touched.key && errors.key && (
                      <div style={{ color: "red", marginTop: 4 }}>
                        {errors.key}
                      </div>
                    )}
                  </InputGroup>

                  <InputGroup>
                    <MediaUploader
                      label="Upload Icon"
                      image={
                        values.icon && typeof values.icon === "string"
                          ? [values.icon]
                          : []
                      }
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        setFieldValue("icon", file);
                      }}
                      style={{
                        container: { paddingTop: 10, gap: 6, marginBottom: 10 },
                        label: { paddingBottom: 10, color: "#555A77" },
                        dropzone: { background: "#F1EFFB" },
                      }}
                    />
                    {touched.icon && errors.icon && (
                      <div style={{ color: "red", marginTop: 4 }}>
                        {errors.icon}
                      </div>
                    )}
                  </InputGroup>

                  <InputGroup>
                    <LabelText>Status</LabelText>
                    <div
                      style={{
                        display: "flex",
                        gap: "1rem",
                        alignItems: "center",
                        marginTop: 8,
                      }}
                    >
                      <label>
                        <input
                          type="radio"
                          name="isActive"
                          value="true"
                          checked={values.isActive === true}
                          onChange={() => setFieldValue("isActive", true)}
                          onBlur={handleBlur("isActive")}
                          style={{ marginRight: 10 }}
                        />
                        Active
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="isActive"
                          value="false"
                          checked={values.isActive === false}
                          onChange={() => setFieldValue("isActive", false)}
                          onBlur={handleBlur("isActive")}
                          style={{ marginRight: 10 }}
                        />
                        Inactive
                      </label>
                    </div>
                    {touched.isActive && errors.isActive && (
                      <div style={{ color: "red", marginTop: 4 }}>
                        {errors.isActive}
                      </div>
                    )}
                  </InputGroup>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingTop: 20,
                }}
              >
                <AcceptButton onClick={() => handleSubmit?.()}>
                  Save
                </AcceptButton>
              </div>
            </>
          );
        }}
      </Formik>
    </Modal>
  );
}

export default AddEditPaymentMethod;
